import React from "react";

const NumberList = ({ style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36" }) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >

        <path
            className="u_fill"
            fill={fill || "#4E525F"}
            fillRule="evenodd"
            d="M15.334 20.974H34V15.65H15.334v5.324Zm0 10.65H34v-5.325H15.334v5.324Zm0-26.623v5.324H34V5.001H15.334ZM5.294 15.65h3.25V5h-1.5l-3.54.957v2.081l1.791-.084v7.696h-.001Zm4.582 8.569c0-1.498-.5-3.246-4-3.246-1.375 0-2.667.25-3.459.666l.041 2.746a6.24 6.24 0 0 1 2.792-.624c1.041 0 1.334.458 1.334 1.165 0 1.082-1.251 2.413-4.584 4.658v2.08l8 .002v-2.788l-3.792.084c2.041-1.248 3.625-2.745 3.625-4.7l.042-.04.001-.003Z"
            clipRule="evenodd"
        />
    </svg>
);

export default NumberList;
